import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Lobby from '@/views/shared/lobby/index.vue'
import { onMounted } from 'vue-demi'
import { useRoute, useRouter } from 'vue-router'
import { omit } from 'lodash'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { useToast } from 'vue-toastification'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const toast = useToast()

onMounted(() => {
  const { errorCode } = route.query
  if (errorCode) {
    router.replace({ ...router.currentRoute, query: omit(route.query, ['errorCode']) })
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'ERROR_SOCIAL_ACCOUNT_LINKING',
      },
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Lobby))
}
}

})